import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export interface PromptRequest {
  type: 'motivation';
  title?: string;
}

interface ActivePrompt extends PromptRequest {
  resolve: (value: string | null) => void;
}

interface PromptStore {
  current: ActivePrompt | null;
  /**
   * Open the prompt and resolve with the entered text, or `null` when the
   * user cancels. A request arriving while another prompt is open settles
   * the previous one as declined — no dangling promises.
   */
  request: (req: PromptRequest) => Promise<string | null>;
  settle: (value: string | null) => void;
}

export const usePromptStore = create<PromptStore>()(
  devtools(
    (set, get) => ({
      current: null,
      request: (req) =>
        new Promise<string | null>((resolve) => {
          get().current?.resolve(null);
          set({ current: { ...req, resolve } });
        }),
      settle: (value) => {
        get().current?.resolve(value);
        set({ current: null });
      },
    }),
    { name: 'prompt-store' }
  )
);
